import querystring from 'querystring'
import request from './http'

 const baseUrl= localStorage.getItem("baseUrl")
// const baseUrl= 'http://192.168.0.147:8083'

// 登录请求方法
const loginreq = (method, url, params) => {
    console.log(params)
    return request({
        method: method,
        url: url,
        withCredentials:true,
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type':'application/json',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};
// 枚举方法类
const tsreq = (method, url, params) =>{
    return  request({
        method: method,
        url:url,
        withCredentials:true,
        changeOrigin: true, // 跨域
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',   

      },
      'Content-Type': "application/json;charset=UTF-8",
          data:JSON.stringify(params)
        
      }).then(res => res.data);

};
// 枚举方法类
const tsreq1 = (method, url, params) =>{
    return  request({
        method: method,
        url: url,
        withCredentials:true,
        changeOrigin: true, // 跨域
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',      
        },
        data:JSON.stringify(params)
        
      }).then(res => res.data);

};
// 通用公用方法
const req = (method, url, params) => {
   
    return request({
        method: method,
        url:url,
        withCredentials:true,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          
        },
        // data: params,
        params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
     
                return ret
            }
        ]
    }).then(res => {
      
      if(!res.data){
        window.location = baseUrl + url + '?'+querystring.stringify(params)
        return 
      }else{
         return res.data
      }
     
    },
    error=>{
        return error
    } 
    
      );
};


// 文件导出
const reqtext = (method, url, params) => {
    // responseType: 'blob',
    return request({
        method: method,
        url:  url,
        withCredentials:true,
       
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            
            token: sessionStorage.getItem('logintoken')
        },
        // data: params,
        params,
        responseType: 'blob',
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                // hideLoading()
                return ret
            }
        ]
    }).then(res =>  {
      console.log('return',res)
      if(res.data.size){
        // window.location = baseUrl + url + '?'+querystring.stringify(params)
      }
      return res} );
 
};
// 文件导出
const reqGet = (url, params) => {
   window.location = baseUrl + url + '?'+querystring.stringify(params)
  
};
export {
    loginreq,
    req,
    tsreq,
    tsreq1,
    reqtext,
    reqGet
}